import Modal from '@mui/material/Modal';
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";

import Tab from "@mui/material/Tab";
import Cropper from "react-cropper";
import TabList from "@mui/lab/TabList";
import FreeTools from './FreeTools.js';
import TabPanel from "@mui/lab/TabPanel";
import TabContext from "@mui/lab/TabContext";
import BusinessCards from "./BusinessCards.js";
import ClientIndex from './ClientIndex/index.js';
import { hasValidAdvisor } from './BusinessCards.js';
import * as ROUTES from "../../../constants/routes.js";
import { updateUser } from "../../../reducers/userReducer.js";
import AnimatedPage from "../../../components/AnimatedPage.js";
import { toggleModal } from "../../../reducers/modalReducer.js";
import { setCompany } from "../../../reducers/companyReducer.js";
import { refreshCompanies } from "../../../reducers/companiesReducer.js";

import { UPDATE_QUERY } from '../../../reducers/commonReducer.js';
import { showMessage, getRequest, postRequest } from "../../../config.js";
import TeamMemberModal from '../../../components/modals/TeamMember/index.jsx';

const cropper = React.createRef(null);

export const UserIcon = ({ color, onClick = () => { } }) => {
	return (
		<svg width="48" height="36" viewBox="0 0 77 71" fill="none" xmlns="http://www.w3.org/2000/svg" className="cp user-advisor-modal-icon" onClick={onClick}>
			<path d="M55.8372 3H14.1628C8.00093 3 3 7.992 3 14.1429V43.8571C3 50.008 8.00093 55 14.1628 55H55.8372C61.9991 55 67 50.008 67 43.8571V14.1429C67 7.992 61.9991 3 55.8372 3ZM62.5349 43.8571C62.5349 47.5417 59.5284 50.5429 55.8372 50.5429H14.1628C10.4716 50.5429 7.46512 47.5417 7.46512 43.8571V14.1429C7.46512 10.4583 10.4716 7.45714 14.1628 7.45714H55.8372C59.5284 7.45714 62.5349 10.4583 62.5349 14.1429V43.8571ZM32.0828 31.5257C33.4223 30.0697 34.2558 28.1383 34.2558 26.0286C34.2558 21.512 30.5944 17.8571 26.0698 17.8571C21.5451 17.8571 17.8837 21.512 17.8837 26.0286C17.8837 28.1383 18.7172 30.0697 20.0567 31.5257C18.0028 32.8331 16.3953 34.7943 15.5619 37.2011C15.1749 38.36 15.7702 39.6377 16.9609 40.024C18.1219 40.4103 19.4019 39.7863 19.7888 38.6274C20.7116 35.9829 23.2121 34.2 26.0698 34.2C28.9274 34.2 31.4577 35.9829 32.3507 38.6274C32.6781 39.5486 33.5414 40.1429 34.4642 40.1429C34.7023 40.1429 34.9405 40.1131 35.1786 40.024C36.3395 39.6377 36.9646 38.36 36.5777 37.2011C35.7442 34.7943 34.1367 32.8331 32.0828 31.5257ZM22.3488 26.0286C22.3488 23.9783 24.0158 22.3143 26.0698 22.3143C28.1237 22.3143 29.7907 23.9783 29.7907 26.0286C29.7907 28.0789 28.1237 29.7429 26.0698 29.7429C24.0158 29.7429 22.3488 28.0789 22.3488 26.0286ZM55.093 23.0571C55.093 24.2754 54.0809 25.2857 52.8605 25.2857H43.9302C42.7098 25.2857 41.6977 24.2754 41.6977 23.0571C41.6977 21.8389 42.7098 20.8286 43.9302 20.8286H52.8605C54.0809 20.8286 55.093 21.8389 55.093 23.0571ZM55.093 34.9429C55.093 36.1611 54.0809 37.1714 52.8605 37.1714H43.9302C42.7098 37.1714 41.6977 36.1611 41.6977 34.9429C41.6977 33.7246 42.7098 32.7143 43.9302 32.7143H52.8605C54.0809 32.7143 55.093 33.7246 55.093 34.9429Z" fill="#151313" />
			<circle cx="58" cy="54" r="14" fill="white" />
			<path d="M58.7846 38.0391C50.4167 38.0391 43.5703 44.8855 43.5703 53.2533C43.5703 61.6212 50.4167 68.4676 58.7846 68.4676C67.1525 68.4676 73.9989 61.6212 73.9989 53.2533C73.9989 44.8855 67.1525 38.0391 58.7846 38.0391ZM65.3267 49.6019L58.3282 58.7305C58.0239 59.0348 57.5675 59.3391 57.111 59.3391C56.6546 59.3391 56.1982 59.1869 55.8939 58.7305L52.2425 54.0141C51.786 53.4055 51.786 52.3405 52.5467 51.8841C53.3075 51.4276 54.2203 51.4276 54.6767 52.1883L57.111 55.3833L62.8925 47.7762C63.3489 47.1676 64.4139 47.0155 65.0225 47.4719C65.7832 47.9283 65.7832 48.8412 65.3267 49.6019Z" fill={color ? color : "#505050"} />
		</svg>
	)
};

export default function Advisor({ }) {
	const navigate = useNavigate();
	const dispatch = useDispatch();

	let user = useSelector((state) => state.user);
	let modal = useSelector((state) => state.modal);
	let companies = useSelector((state) => state.companies);
	let { selectedCompany } = useSelector(state => state.company);
	let company = { ...selectedCompany };

	let [tab, setTab] = useState('index');
	let [action, setAction] = useState("add");
	let [advisors, setAdvisors] = useState([]);
	let [subTab, setSubTab] = useState('Client');
	let [loading, setLoading] = useState(false);
	let [companyId, setCompanyId] = useState('');
	let [investors, setInvestors] = useState([]);
	let [noClients, setNoClients] = useState(false);
	let [promptScore, setPromptScore] = useState(0);
	let [selectAll, setSelectAll] = useState(false);
	let [uploadImage, setUploadImage] = useState("");
	let [permissions, setPermissions] = useState({});
	let [selectedData, setSelectedData] = useState('');
	let [hideUserIcon, setHideUserIcon] = useState(false);
	let [qualifiedLeads, setQualifiedLeads] = useState([]);
	let [updateType, setUpdateType] = useState("profileImage");
	let [profileClass, setProfileClass] = useState("client-profile");
	let [countCertificate, setCountCertificate] = useState({ None: 0, Bronze: 0, Silver: 0, Gold: 0 });
	let [advisorData, setAdvisorData] = useState({ firstName: "", lastName: "", email: "", designation: "", phone: '', linkedIn: '', profile: "" });
	let [sections, setSections] = useState([
		{ sectionNo: "D001", sectionName: "Key Shareholder/Investor Documents" },
		{ sectionNo: "D002", sectionName: "Commercial Activities" },
		{ sectionNo: "D003", sectionName: "Legal" },
		{ sectionNo: "D004", sectionName: "Property" },
		{ sectionNo: "D005", sectionName: "Intellectual Property" },
		{ sectionNo: "D006", sectionName: "Insurance" },
		{ sectionNo: "D007", sectionName: "Corporate Structure" },
		{ sectionNo: "D008", sectionName: "State Aid" },
		{ sectionNo: "D009", sectionName: "Finance" },
		{ sectionNo: "D010", sectionName: "General Data Protection Regulations (GDPR)" },
		{ sectionNo: "D011", sectionName: "Shares & Share Options" },
		{ sectionNo: "D012", sectionName: "Taxation" },
		{ sectionNo: "D013", sectionName: "Social Media" },
		{ sectionNo: "D014", sectionName: "Key People" },
		{ sectionNo: "D015", sectionName: "Human Resources" },
		{ sectionNo: "D016", sectionName: "Environmental, Social & Governmental (ESG)" },
		{ sectionNo: "D017", sectionName: "Key Advisors - Engagement Letters & Corrrspondence" },
		{ sectionNo: "D018", sectionName: "IT Systems" },
		{ sectionNo: "D019", sectionName: "Regulatory" },
		{ sectionNo: "D020", sectionName: "Standards" },
		{ sectionNo: "DEPF006", sectionName: "Warranty Disclosure" },
		{ sectionNo: "DEPF007", sectionName: "Directors Questionnaire" },
		{ sectionNo: "DEPF008", sectionName: "InvestorMatch" },
		{ sectionNo: "IR", sectionName: "Investment Readiness" },
	]);

	const spinner = document.getElementById("e1jygW4piZH1");

	function hasAllPermissions(companySections, userPermission) {
		return companySections.every(section => userPermission[section.sectionNo]);
	}

	useEffect(() => {
		if (advisorData && advisorData?.permissions && company && company['memberPermissions']) {
			setSelectAll(hasAllPermissions(company?.['sections'], advisorData?.permissions));
		}
	}, [advisorData, company]);

	useEffect(() => {
		let tabName = window.location.hash.replaceAll('#', '');
		if (tabName && tabName.includes('?')) {
			setTab(tabName.split('?')[0]);
			setSubTab(tabName.split('?')[1]);
		}
		else {
			if (tabName) setTab(tabName);
			else setTab('index');
		}
		let isWorkflowOpen = localStorage.getItem('isWorkflowOpen');
		if (isWorkflowOpen) {
			setTab('your-firm');
			localStorage.removeItem('isWorkflowOpen');
		}

		let isManualAdd = localStorage.getItem('isManualAdd');
		if (isManualAdd) localStorage.removeItem('isManualAdd');
	}, []);

	useEffect(() => {
		getAdvisors();
		getCompanies();
		dispatch(toggleModal({ open: "" }));
		if (user?.role) setProfileClass(user["role"] == "Advisor" ? "advisor-profile" : user["role"] == "Investor" ? "investor-profile" : "client-profile");
	}, []);

	useEffect(() => {
		if (user && user?.['companyId']?.['_id']) {
			getQualifiedLeads(user?.['companyId']?.['_id']);
			setCompanyId(user?.['companyId']?.['_id']);
			getCompany(user?.['companyId']?.['_id']);
		}
	}, [user]);

	useEffect(() => {
		if (companies.length > 0) {
			const initialCount = { None: 0, Bronze: 0, Silver: 0, Gold: 0 };

			companies.forEach(company => {
				if (company?.cLevel) {
					initialCount[company.cLevel] = (initialCount[company.cLevel] || 0) + 1;
				}
			});

			setCountCertificate(initialCount); // Set fresh count to avoid double values
		}
	}, [companies]);

	const getCompany = async (id) => {
		let res = await getRequest(`/company/get/${id}`);
		if (res['code'] == 200) {
			dispatch(setCompany(res['body']))
			// Filter out DEPF005, DEPN004
			const excludeSections = ['DEPF005', 'DEPN004'];
			const filteredSections = res['body']['sections'].filter(section => !excludeSections.includes(section.sectionNo));
			const additionalSections = [{ sectionNo: "IR", sectionName: "Investment Readiness" }];
			// Only add if not already present
			const existingSectionNos = filteredSections.map(s => s.sectionNo);
			const newSections = additionalSections.filter(s => !existingSectionNos.includes(s.sectionNo));
			setSections([...filteredSections, ...newSections])
		};
	};

	const getCompanies = async () => {
		let response = await getRequest(`/user/myProfile`);
		if (response["body"]) {
			let { user, companies } = response["body"];
			let groups = companies.filter(({ group }) => group == "Parent");
			let standard = companies.filter(({ group }) => group != "Parent");
			companies = groups.concat(standard);

			if (companies.length == 0) setNoClients(true);

			dispatch(updateUser(user));
			dispatch(refreshCompanies(companies));
		}
	};

	const getAdvisors = async () => {
		let response = await getRequest(`/user/getAdvisor`);
		if (response["code"] == 200 && response["body"]) {
			setAdvisors(response["body"]["advisors"]);
			setInvestors(response["body"]["investors"]);
		}
	};

	const getQualifiedLeads = async (investorId, query) => {
		let endpoint = `/company/getQualifiedLeads/${investorId}`
		if (query) endpoint = `${endpoint}/?${query}`;
		setLoading(true);
		let response = await getRequest(endpoint);
		if (response["code"] == 200 && response["body"]) {
			setPromptScore(response['body']['promptScore']);
			setQualifiedLeads(response['body']['qualifiedLeads']);
			dispatch(UPDATE_QUERY({ totalPages: response['body']['totalPages'] }))
		}
		setLoading(false);
	};

	const handleAddAdvisor = async () => {
		await setAction("add");
		await setPermissions({});
		await setUpdateType('profileImage');
		await setAdvisorData({ firstName: "", lastName: "", email: "", designation: "", phone: '', linkedIn: '', profile: "" });
		dispatch(toggleModal({ open: "teamPopup" }));
	};

	const handleAdvisor = async (advisor, action) => {
		if (advisor) {
			setAdvisorData({
				firstName: advisor["firstName"],
				lastName: advisor["lastName"],
				email: advisor["email"],
				designation: advisor["designation"],
				isDisable: user?._id === advisor?._id ? false : true,
				isSuperUser: user?.["createdBy"] ? false : true,
				phone: advisor["phone"] && advisor["phone"] !== undefined && advisor["phone"] !== 'undefined' ? advisor["phone"] : '+44',
				linkedIn: advisor["linkedIn"] ? advisor["linkedIn"] : '',
				profile: advisor["profile"] ? advisor["profile"] : ''
			});

			if (advisor["permissions"]) {
				setPermissions(advisor["permissions"]);
				setSelectAll(sections.map((sec) => sec.sectionNo).every(section => advisor["permissions"][section]))
			}
		}
		setAction(action);
		dispatch(toggleModal({ open: "teamPopup" }));
	};

	const handleCompanyMember = async (data, action) => {

		setAction(action);
		dispatch(toggleModal({ open: "teamPopup" }));
	}

	const updateProfile = async () => {
		let attachment = [];
		if (cropper.current && uploadImage) {
			setLoading(true)
			let imageToUpload = cropper?.current?.getCroppedCanvas()?.toDataURL();
			let res = await fetch(imageToUpload);
			let blob = await res.blob();
			const coverFile = new File([blob], "profile image", { type: "image/png" });
			attachment.push(coverFile);

			if (updateType == 'profileImage') {
				const response = await postRequest(`/user/upload/advisor/profile`, { attachment });
				if (response || response["code"] == 200) setAdvisorData({ ...advisorData, profile: response?.message })
				else setLoading(false)
			}

			if (updateType == 'companyLogo') {
				const response = await postRequest(`/company/updateLogo/${companyId}`, { attachment });
				if (response || response["code"] == 200) await getCompany(companyId);
			}
			setUploadImage('');
			dispatch(toggleModal({ open: "" }));
			if (updateType == 'profileImage') dispatch(toggleModal({ open: "teamPopup" }));
			setLoading(false)
		}
		else showMessage("Please upload image first")
	};

	const handleUploadImage = async (e) => {
		let profile = e.target.files[0];
		if (profile && profile.size > 5 * 1024 * 1024)
			return showMessage("Photo Size must be less than 5MB");
		profile = await URL.createObjectURL(profile);
		setUploadImage(profile);
	};

	const onModalClose = () => {
		dispatch(toggleModal({ open: "" }));
		setSelectAll(false)
		setLoading(false)
		setAdvisorData({ firstName: "", lastName: "", email: "", designation: "", phone: '', linkedIn: '', profile: "" })
		setHideUserIcon(false)
	};

	const onEditClick = (advisor) => {
		if (advisor?.['editRoute'] === 'current-loggedIn') { navigate(ROUTES.PROFILE) }
		else { handleAdvisor(advisor, "edit"), setHideUserIcon(true) }
	};

	const showEditButton = (advisor) => {
		if (user?.["createdBy"] && advisor?._id === user?._id) { return true }
		if (!user?.["createdBy"]) { return true }
		else { return false }
	};

	const handleEditRoute = (advisor) => {
		if (user?.["createdBy"] && advisor?._id === user?._id) { return "current-loggedIn" }
		if (!user?.["createdBy"] && advisor?._id === user?._id) { return "current-loggedIn" }
		if (!user?.["createdBy"] && advisor?._id !== user?._id) { return 'edit-modal' }
		else { return "edit-modal" }
	};

	const cancelUpdateProfile = () => {
		setUploadImage("");
		dispatch(toggleModal({ open: "" }));
		if (updateType == 'profileImage') dispatch(toggleModal({ open: "teamPopup" }))
	};

	return (
		<AnimatedPage>
			{spinner.classList.remove("op0")}
			{user?.role && spinner.classList.add("op0")}
			<TabContext value={tab}>
				<div className="dashboard-container pt1rem pb1rem df fdc poppins-font-style * ">
					<div className={`pr w100 mt0rem mb0rem px2rem py0-5rem`} style={{ backgroundColor: user['role'] == 'Advisor' ? '#fff6a680' : '#aafed680', borderRadius: '1rem 1rem 0 0' }}>
						<div className='dg gtcr2 jcsb aic top-admin-area'>
							<div className='left-area'>
								{user['role']
									? <ul className='c27 df aic lisn'>
										<li className='fs14px c27'>{user["role"] == "Investor" ? `Investor` : "Advisor"} View</li>
										<li className='fs14px c27'>/</li>
										<li className={`${tab !== `index` && 'fw600'} ttc fs14px c27`}>{tab == 'index' ? <>{user['role'] == 'Investor' ? 'Portfolio' : 'Client'} Index</> : tab.replaceAll('-', ' ')}</li>
										{tab == `index` && <>
											<li className='fs14px c27'>/</li>
											<li className='fs14px fw600 c27'>{user["role"] == "Advisor" ? `Client` : "Investor"}</li>
										</>}
									</ul>
									: <ul className='c27 df aic lisn'>
										<li className='fs14px c27'>View</li>
										<li className='fs14px c27'>/Tab</li>
										<li className={`ttc fs14px c27`}>/Index</li>
									</ul>
								}
							</div>
							<div className='right-area df jcfe'>
								<div className="ass df">
									{/* Owner */}
									<div className="df fs1rem aic">
										<div className='mr1rem tar df fdc'>
											{user?.['firstName'] ? <span className="c15 ase">{user?.['firstName'] + " " + (user?.['lastName'] ?? "")}</span> : <span className="c15 ase">Name</span>}
											{user?.['companyId']?.['creatorId']?.['_id'] == user['_id'] && <span className={`c3 fs0-75rem ase`}>Admin</span>}
										</div>
										{user?.['firstName']
											? <span className={`w40px h40px df jcc aic br100 bg3 c1 bw3px bss bo30`}>
												{user?.['profile']
													? <img src={user?.['profile']} className={`w40px h40px df jcc aic br100`} data-tooltip={user?.['firstName'] + " " + (user?.['lastName'] ?? "")} />
													: <span className={`w30px h30px df jcc aic br100`} data-tooltip={user?.['firstName'] + " " + (user?.['lastName'] ?? "")}>{user?.['firstName'] ? (user?.['firstName']?.[0] + (user?.['lastName'] ? user?.['lastName']?.[0] : "")) : "?"}</span>
												}</span>
											: <span className={`w40px h40px df jcc aic br100 bg3 c1 bw3px bss bo30`}>
												<span className={`w30px h30px df jcc aic br100`}>?</span>
											</span>
										}
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className={`pr w100 mt0rem mb1rem`}>
						<div className={`${tab == `index` && "client-tab"} bg1 new-shadow br20px pt2rem pb4rem safaripb7rem px3rem mb2rem pr`} style={{ borderRadius: '0 0 1rem 1rem ' }}>

							<div className='df fww company-details-area'>
								<div className='left-company-area w33'>
									<div className='df '>
										<span className='new-shadow bw0px bss br10px bsbb w6rem h6rem center-logo-area tac df aic jcc pr' style={{ borderColor: '#E3E3E3' }}>
											<img src={company?.["logo"]} className="w100 cp br10px" />
											{user['role'] != 'Guest' &&
												<div className="input-file">
													<span className="add-btn bg5" onClick={() => { setUpdateType('companyLogo'), dispatch(toggleModal({ open: "uploadProfile" })), setUploadImage("") }}>
														<svg viewBox="0 0 487 487" className="zi3">
															<g>
																<path
																	d="M308.1,277.95c0,35.7-28.9,64.6-64.6,64.6s-64.6-28.9-64.6-64.6s28.9-64.6,64.6-64.6S308.1,242.25,308.1,277.95z
																M440.3,116.05c25.8,0,46.7,20.9,46.7,46.7v122.4v103.8c0,27.5-22.3,49.8-49.8,49.8H49.8c-27.5,0-49.8-22.3-49.8-49.8v-103.9
																v-122.3l0,0c0-25.8,20.9-46.7,46.7-46.7h93.4l4.4-18.6c6.7-28.8,32.4-49.2,62-49.2h74.1c29.6,0,55.3,20.4,62,49.2l4.3,18.6H440.3z
																M97.4,183.45c0-12.9-10.5-23.4-23.4-23.4c-13,0-23.5,10.5-23.5,23.4s10.5,23.4,23.4,23.4C86.9,206.95,97.4,196.45,97.4,183.45z
																M358.7,277.95c0-63.6-51.6-115.2-115.2-115.2s-115.2,51.6-115.2,115.2s51.6,115.2,115.2,115.2S358.7,341.55,358.7,277.95z"
																/>
															</g>
														</svg>
													</span>
												</div>
											}
										</span>
										<div className='ml1rem'>
											<a target="_blank" href={user?.["companyId"]?.["cWebsite"]} className="fs1-5rem fw500 c15">{user?.["companyId"]?.["cName"] || 'Company Name'}</a>
											<p className="ass fs1rem my0-5rem c15">Company Number: <span className="fw600">{user?.["companyId"]?.['ukRegNo'] || '-'}</span></p>
											<p className="ass fs1rem my0-5rem c15">Subscription: <span className="fw600 c7 mra tal">Portfolio PRO</span></p>
										</div>

									</div>


								</div>
								<div className='center-logo-area w33 df jcc fww fdc mla mra pr'>
									<div className='company-name'>
										<h2 className='c15 fs2rem tac w100 fw500 mb2rem'>{user?.["role"] == "Investor" ? 'Investor' : user?.["role"] == "Advisor" ? 'Advisor' : ''} View</h2>
									</div>
								</div>
								<div className='right-certificate-area w33 df jce'>
									{tab == 'index' && <>
										<div className='certficate-area bg19 px1rem py0-5rem br10px pa r0 mr3rem'>
											<p className='c15 fs1rem mb0-5rem'>{user['role'] == 'Advisor' ? 'Number of Clients' : 'Portfolio'}</p>
											<div className='certficate-box df bg1 br8px bss bw1px bo31 bsbb p0-5rem mb0-5rem aife'>
												<div className='text-box pr1rem w100px'>
													<h4 className='fw500 c15 fs1rem'>{countCertificate['None']}</h4>
													<p className='fs14px c32 mb0-5rem'>Not Yet Certified</p>
												</div>
												<div className='img-box'>
													<img src={require(`../../../../images/advisor-dashboard/banner-certification-1.png`)} alt="TODO" />
												</div>
											</div>
											<div className='certficate-box df bg1 br8px bss bw1px bo31 bsbb p0-5rem mb0-5rem aife'>
												<div className='text-box pr1rem w100px'>
													<h4 className='fw500 c15 fs1rem'>{countCertificate['Bronze']}</h4>
													<p className='fs14px c32 mb0-5rem'>Bronze</p>
												</div>
												<div className='img-box'>
													<img src={require(`../../../../images/advisor-dashboard/banner-certification-2.png`)} alt="TODO" />
												</div>
											</div>
											<div className='certficate-box df bg1 br8px bss bw1px bo31 bsbb p0-5rem mb0-5rem aife'>
												<div className='text-box pr1rem w100px'>
													<h4 className='fw500 c15 fs1rem'>{countCertificate['Silver']}</h4>
													<p className='fs14px c32 mb0-5rem'>Silver</p>
												</div>
												<div className='img-box'>
													<img src={require(`../../../../images/advisor-dashboard/banner-certification-3.png`)} alt="TODO" />
												</div>
											</div>
											<div className='certficate-box df bg1 br8px bss bw1px bo31 bsbb p0-5rem mb0-5rem aife'>
												<div className='text-box pr1rem w100px'>
													<h4 className='fw500 c15 fs1rem'>{countCertificate['Gold']}</h4>
													<p className='fs14px c32 mb0-5rem'>Gold</p>
												</div>
												<div className='img-box'>
													<img src={require(`../../../../images/advisor-dashboard/banner-certification-4.png`)} alt="TODO" />
												</div>
											</div>
										</div>
									</>}
								</div>
							</div>
							<div className='user-area bg19 br30px  mt2rem df aic' style={{ padding: '0.25rem' }}>
								<div className='user-advisor df aic'>
									{/* Advisor Team */}
									{user['role'] == 'Advisor' &&
										<div className="df fs0-75rem">
											{advisors && advisors.length > 0
												? <div className='df'>
													{advisors
														?.sort((a, b) => {
															const aCond = user?.companyId?.creatorId?._id?.toString() === a?._id?.toString();
															const bCond = user?.companyId?.creatorId?._id?.toString() === b?._id?.toString();
															return bCond - aCond;
														})
														.map(advisor => {
															return (
																<div className='pr df bg1 br50px mr0-5rem bw2px bss bsbb aic' style={{ borderColor: '#DBDFEE', padding: '0.25rem 1rem 0.25rem 0.5rem' }}>
																	<span key={advisor['_id']}
																		data-tooltip={
																			advisor['designation']
																				? advisor['designation'].toLowerCase().replace(/\b\w/g, char => char.toUpperCase())
																				: user?.['companyId']?.['creatorId']?.['_id'] == advisor?.['_id']
																					? "Admin"
																					: "??"
																		}
																		className={`w30px h30px df jcc aic br100 bg4 c1 mr0-5rem ${user['_id'] == advisor['_id'] && ' bw3px bss bo7'}`}>
																		{advisor?.['profile']
																			? <img src={advisor?.['profile']} className={`w30px h30px df jcc aic br100 bg4 c1 ${user['_id'] == advisor['_id'] && ' bw3px bss bo7'}`} data-tooltip={advisor['designation'] ? (advisor['designation']) : "??"} />
																			: advisor['firstName'] ? (advisor['firstName']?.[0] + (advisor['lastName'] ? advisor['lastName']?.[0] : "")) : "??"}
																	</span>
																	<span className='c15 ttc'>
																		{advisor['firstName'] ? (advisor['firstName'] + " " + (advisor?.['lastName'] ?? "")) : "??"}<br />
																		{user?.['companyId']?.['creatorId']?.['_id'] == advisor?.['_id'] && <span className='c4 fs0-75rem'>Admin</span>}
																	</span>
																</div>
															)
														})}
												</div>
												: <div className="df bg1 br100 bw2px bss p0-5rem bsbb" style={{ borderColor: '#DBDFEE' }}>
													<span data-tooltip={"Register to show your name here"} className={`w40px h40px df jcc aic br100 bg4 c1 mr0-5rem`}>??</span>
												</div>
											}
										</div>
									}
									{/* Investor Team */}
									{user['role'] == 'Investor' &&
										<div className="df fs0-75rem">
											{investors && investors.length > 0
												? <div className="df">
													{investors?.sort((a, b) => {
														const aCond = user?.companyId?.creatorId?._id?.toString() === a?._id?.toString();
														const bCond = user?.companyId?.creatorId?._id?.toString() === b?._id?.toString();
														return bCond - aCond;
													})
														.map(investor => (
															<div className='df bg1 br50px mr0-5rem bw2px bss pr1rem p0-5rem bsbb aic' style={{ borderColor: '#DBDFEE', paddingRight: '1rem' }}>
																<span key={investor['_id']} data-tooltip={investor['designation'] ? (investor['designation']) : "??"} className={`w30px h30px df jcc aic br100 bg4 c1 mr0-5rem ${user['_id'] == investor['_id'] && ' bw3px bss bo7'}`}>
																	{investor?.['profile']
																		? <img src={investor?.['profile']} className="w40px h40px df jcc aic br100 bg4 c1" data-tooltip={investor['designation'] ? (investor['designation']) : "??"} />
																		: investor['firstName'] ? (investor['firstName']?.[0] + (investor['lastName'] ? investor['lastName']?.[0] : "")) : "??"}
																</span>
																<span className='c15'>
																	{investor['firstName'] ? (investor['firstName'] + " " + (investor?.['lastName'] ?? "")) : "??"}
																	<br />
																	{user?.['companyId']?.['creatorId']?.['_id'] == investor?.['_id'] && <span className='c4 fs0-75rem'>Admin</span>}
																</span>
															</div>
														))}
												</div>
												: <div className="df bg1 br100 bw2px bss p0-5rem bsbb" style={{ borderColor: '#DBDFEE' }}>
													<span data-tooltip={"Register to show your name here"} className={`w40px h40px df jcc aic br100 bg4 c1 mr0-5rem`}>??</span>
												</div>
											}
										</div>
									}
									<div onClick={() => handleAddAdvisor()} className='df mr0-5rem p0-5rem bsbb aic cp'>
										<span className='bg1 bsbb p0-5rem mr0-5rem br100 w40px h40px tac df jcc aic'>
											<svg className='h30px w30px' width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
												<g clip-path="url(#clip0_2656_879)">
													<path d="M19 0C8.52298 0 0 8.52298 0 19C0 29.477 8.52298 38 19 38C29.477 38 38 29.477 38 19C38 8.52298 29.477 0 19 0Z" fill="#4A67FF" />
													<path d="M27.3098 20.5825H20.5805V27.3118C20.5805 28.1859 19.8714 28.895 18.9973 28.895C18.1232 28.895 17.4141 28.1859 17.4141 27.3118V20.5825H10.6848C9.8107 20.5825 9.10156 19.8734 9.10156 18.9993C9.10156 18.1252 9.8107 17.416 10.6848 17.416H17.4141V10.6868C17.4141 9.81265 18.1232 9.10352 18.9973 9.10352C19.8714 9.10352 20.5805 9.81265 20.5805 10.6868V17.416H27.3098C28.1839 17.416 28.893 18.1252 28.893 18.9993C28.893 19.8734 28.1839 20.5825 27.3098 20.5825Z" fill="#FAFAFA" />
												</g>
												<defs>
													<clipPath id="clip0_2656_879">
														<rect width="38" height="38" fill="white" />
													</clipPath>
												</defs>
											</svg>
										</span>
										<span className='c15'>Add to team</span>
									</div>
								</div>
							</div>
							<div className='tabs-navlist df aic jcc mt2rem'>
								<TabList onChange={(e, value) => (value == "your-firm" && companyId) ? navigate(`/company/${companyId}`) : setTab(value)}>
									{/* <Tab onClick={() => navigate(`#free-tools`)} className="fs1rem fw600 c3" label={`Your Tools`} value="free-tools" /> */}
									{<Tab onClick={() => companyId && navigate(`/company/${companyId}`)} className={`fs1rem fw600 c3`} label={`Your Firm`} value="your-firm" />}
									<Tab onClick={() => navigate(`#index`)} className="fs1rem fw600 c3" label={user["role"] == "Investor" ? `Portfolio Index` : "Client Index"} value={`index`} />
								</TabList>
							</div>
						</div>
					</div>
				</div>
				<div className={`dahboard-tabs ${user['role'] == 'Investor' ? 'investor-bg' : 'advisor-bg'}`}>
					<TabPanel className="w100" value='index'>
						<ClientIndex sectionsWithChecklist={sections} company={company} companyId={companyId} qualifiedLeads={qualifiedLeads} promptScore={promptScore} noClients={noClients} advisors={advisors} getAdvisors={getAdvisors} investors={investors}
							getQualifiedLeads={getQualifiedLeads} setQualifiedLeads={setQualifiedLeads} handleAddAdvisor={handleAddAdvisor} handleAdvisor={handleAdvisor} setSelectedData={setSelectedData} showEditButton={showEditButton} loading={loading}
							handleEditRoute={handleEditRoute} hasValidAdvisor={hasValidAdvisor} subTab={subTab} setSubTab={setSubTab} handleCompanyMember={handleCompanyMember} />
					</TabPanel>
					<TabPanel className="w100 your-firm" value="your-firm">Your Firm</TabPanel>
					<TabPanel className="w100 free-tools" value="free-tools"><FreeTools /></TabPanel>
				</div>
			</TabContext>

			{/* How Its Works */}
			<Modal open={modal["open"] == "howItsWorks"} onClose={() => dispatch(toggleModal({ open: "" }))}
				className="backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic poppins-font-style *">
				<div className="mah80 bg1 shadow w100 p3rem bsbb df fdc m1rem maw70 pr pt3rem br15px pr poppins-font-style *  ">
					<div className='content-area'>
						<div className='title-area df aic mb2rem'>
							<i className='icon mr2rem'>
								<svg width="65" height="65" viewBox="0 0 65 65" fill="none" xmlns="http://www.w3.org/2000/svg">
									<g clip-path="url(#clip0_2711_6886)">
										<path d="M55.3081 16.9844H34.8101C32.9936 16.9867 31.5217 18.4586 31.5195 20.2749V48.879C31.5277 49.4272 31.9786 49.8649 32.5267 49.8568C32.7459 49.8535 32.9579 49.7778 33.1296 49.6414L39.9276 44.0622H55.3081C57.1241 44.0614 58.5965 42.5902 58.5987 40.7742V20.2749C58.5964 18.4586 57.1245 16.9865 55.3081 16.9844ZM56.6284 40.7744C56.6268 41.5025 56.0362 42.0919 55.308 42.0919H39.5754C39.3474 42.0924 39.1265 42.1714 38.9498 42.3154L33.4898 46.7963V20.2749C33.4905 19.5458 34.081 18.9547 34.8101 18.9533H55.3081C56.0372 18.9549 56.6277 19.546 56.6285 20.2749L56.6284 40.7744Z" fill="#4A67FF" stroke="#4A67FF" stroke-width="1.5" />
										<path d="M45.0595 22.8477C42.6548 22.8507 40.7062 24.7993 40.7031 27.204C40.7031 27.7478 41.1439 28.1886 41.6877 28.1886C42.2314 28.1886 42.6721 27.7478 42.6721 27.204C42.7034 25.8858 43.7975 24.8428 45.1157 24.8741C46.3897 24.9045 47.4153 25.93 47.4456 27.204C47.4456 28.1045 47.0475 28.435 46.2201 29.0362C44.8828 29.7902 44.0607 31.2114 44.0738 32.7467C44.0746 33.2904 44.516 33.7306 45.0596 33.7298C45.6022 33.729 46.042 33.2894 46.0428 32.7467C46.0428 31.601 46.575 31.2151 47.3794 30.6301C50.9962 28.6109 49.4538 22.8842 45.0595 22.8477Z" fill="#4A67FF" stroke="#4A67FF" stroke-width="1.5" />
										<path d="M44.3569 36.7748C43.9857 37.1762 44.0102 37.8025 44.4116 38.1736C44.7909 38.5243 45.3763 38.5243 45.7557 38.1736C46.1269 37.7721 46.1024 37.1459 45.7009 36.7748C45.3216 36.424 44.7362 36.424 44.3569 36.7748Z" fill="#4A67FF" stroke="#4A67FF" stroke-width="1.5" />
										<path d="M26.3449 15.6714C26.856 15.8566 27.4206 15.5924 27.6059 15.0813C27.7912 14.5702 27.527 14.0056 27.0158 13.8202C27.004 13.8159 26.9921 13.8118 26.98 13.808C22.5891 12.4266 18.0369 11.6231 13.4384 11.418C12.8942 11.4313 12.4637 11.8833 12.4769 12.4275C12.4884 12.9039 12.8391 13.3036 13.3097 13.3774C17.7359 13.5738 22.1176 14.3449 26.3449 15.6714Z" fill="#4A67FF" stroke="#4A67FF" stroke-width="1.5" />
										<path d="M13.3109 20.2751C17.8392 20.5015 22.3221 21.287 26.6575 22.6138C27.2034 22.6031 27.6373 22.1521 27.6266 21.6062C27.6186 21.1975 27.36 20.8358 26.9757 20.6963C22.5845 19.316 18.0324 18.5135 13.4341 18.3089C12.8898 18.2964 12.4385 18.7277 12.426 19.2719C12.4144 19.786 12.7995 20.2227 13.3109 20.2751Z" fill="#4A67FF" stroke="#4A67FF" stroke-width="1.5" />
										<path d="M13.3115 27.1658C17.8439 27.3929 22.3308 28.1793 26.6703 29.5071C27.2162 29.4965 27.65 29.0454 27.6393 28.4995C27.6313 28.0908 27.3727 27.7291 26.9884 27.5896C22.5937 26.2082 18.038 25.4048 13.4359 25.1995C12.8916 25.1861 12.4395 25.6164 12.4261 26.1608C12.4136 26.6756 12.7992 27.1134 13.3115 27.1658Z" fill="#4A67FF" stroke="#4A67FF" stroke-width="1.5" />
										<path d="M13.3096 34.0611C15.895 34.2139 18.4689 34.5217 21.0174 34.9833C21.5552 35.0631 22.0559 34.6917 22.1357 34.1538C22.2111 33.645 21.882 33.1638 21.3804 33.0495C18.7532 32.5733 16.0997 32.2568 13.4341 32.1016C12.8905 32.1078 12.4548 32.5535 12.461 33.0973C12.4666 33.5842 12.8273 33.994 13.3096 34.0611Z" fill="#4A67FF" stroke="#4A67FF" stroke-width="1.5" />
										<path d="M26.6688 43.2948C27.2139 43.2863 27.6489 42.8374 27.6403 42.2922C27.6339 41.8814 27.3736 41.5175 26.987 41.3787C22.593 39.9967 18.0375 39.1932 13.4359 38.9886C12.8916 38.9753 12.4395 39.4056 12.4261 39.9499C12.4134 40.4647 12.7991 40.9024 13.3113 40.9549C17.843 41.1821 22.3295 41.968 26.6688 43.2948Z" fill="#4A67FF" stroke="#4A67FF" stroke-width="1.5" />
										<path d="M13.4343 45.884C12.8911 45.8578 12.4297 46.2768 12.4035 46.8199C12.3779 47.352 12.7799 47.8079 13.3111 47.8489C16.6559 48.0346 19.9788 48.5043 23.2439 49.2531C23.7776 49.3607 24.2975 49.0152 24.405 48.4815C24.5071 47.9749 24.2008 47.4755 23.703 47.337C20.3276 46.5617 16.8923 46.0755 13.4343 45.884Z" fill="#4A67FF" stroke="#4A67FF" stroke-width="1.5" />
										<path d="M63.031 8.70062H58.5989V4.33347C58.5989 3.78895 58.1575 3.34766 57.6131 3.34766C41.0719 3.34766 34.5164 7.11228 32.5001 8.6831C30.4836 7.11215 23.9295 3.34766 7.38693 3.34766C6.84317 3.34766 6.40238 3.78845 6.40238 4.33207V4.33347V8.70062H1.97035C0.882724 8.70215 0.00152347 9.58335 0 10.671V59.589C0.000761735 60.6769 0.88247 61.5586 1.97035 61.5593H23.4786C24.0227 61.5391 24.4474 61.0817 24.4272 60.5377C24.4082 60.0219 23.9944 59.6081 23.4786 59.5891H1.97035V10.671H6.40251V54.9143C6.40175 55.4573 6.84127 55.8981 7.38426 55.8989H7.38693C12.7032 55.8292 18.011 56.3483 23.2131 57.4467C26.2491 58.2308 29.5073 59.1124 31.8541 61.2993C32.1066 61.6703 32.612 61.7663 32.983 61.5137C33.0673 61.4564 33.14 61.3836 33.1974 61.2993C34.8368 59.7629 36.8409 58.6699 39.0204 58.1238C45.0769 56.4772 51.3417 55.7253 57.6159 55.8921C58.1597 55.8921 58.6009 55.4516 58.6017 54.9076V47.6682C58.5815 47.1241 58.1241 46.6994 57.5801 46.7196C57.0642 46.7388 56.6505 47.1524 56.6315 47.6682V53.9352C42.8258 54.0612 36.2486 56.8548 33.4833 58.5855V53.804C33.5035 53.2598 33.0789 52.8024 32.5347 52.7822C31.9906 52.762 31.5332 53.1867 31.513 53.7309C31.5121 53.7552 31.5121 53.7796 31.513 53.804V58.5774C28.7396 56.8455 22.1557 54.0612 8.37426 53.9352V5.32741C24.6716 5.48178 30.3564 9.44141 31.5101 10.4177V14.0306C31.5302 14.5747 31.9877 14.9994 32.5318 14.9792C33.0476 14.9601 33.4612 14.5464 33.4804 14.0306V10.4177C34.595 9.43862 40.1267 5.47493 56.6285 5.32334V14.0306C56.6487 14.5747 57.1061 14.9994 57.6501 14.9792C58.166 14.9601 58.5797 14.5464 58.5988 14.0306V10.671H63.0309V59.589H41.5119C40.9678 59.6092 40.5431 60.0666 40.5633 60.6106C40.5825 61.1264 40.9961 61.5402 41.5119 61.5592H63.0309C64.1177 61.5563 64.9976 60.6756 64.9999 59.5888V10.671C64.9978 9.58424 64.1178 8.70367 63.031 8.70062Z" fill="#4A67FF" stroke="#4A67FF" stroke-width="1.5" />
									</g>
									<defs>
										<clipPath id="clip0_2711_6886">
											<rect width="65" height="65" fill="white" />
										</clipPath>
									</defs>
								</svg>
							</i>
							<h2 className='fs1-75rem c15 fw500'>How it works?</h2>
						</div>
						<div className='registration-inner df fww pr'>
							<div className='registration-box w33 p1rem bsbb mb2rem'>
								<h4 className='c15 fs1-5rem fw500 pl3rem pr mb0-5rem'>
									<span className='numer br100 w2rem h2rem fs1rem bg17 c15 pa l0 tac df aic jcc t0 mt0-5rem'>1</span>
									Add Company
								</h4>
								<p className='c14 fs1-25rem pl3rem'>Add one or more client companies and your team colleagues.</p>
							</div>
							<div className='registration-box w33 p1rem bsbb mb2rem'>
								<h4 className='c15 fs1-5rem fw500 pl3rem pr mb0-5rem'>
									<span className='numer br100 w2rem h2rem fs1rem bg17 c15 pa l0 tac df aic jcc t0 mt0-5rem'>2</span>
									Activate Pro Subscription
								</h4>
								<p className='c14 fs1-25rem pl3rem'>Either you or your client can activate a subscription. If you, you can later recover in disbursements.</p>
							</div>
							<div className='registration-box w33 p1rem bsbb mb2rem'>
								<h4 className='c15 fs1-5rem fw500 pl3rem pr mb0-5rem'>
									<span className='numer br100 w2rem h2rem fs1rem bg17 c15 pa l0 tac df aic jcc t0 mt0-5rem'>3</span>
									Client Authorization
								</h4>
								<p className='c14 fs1-25rem pl3rem'>Platform manages your client’s access to their module and data.</p>
							</div>
							<div className='registration-box w33 p1rem bsbb mb2rem'>
								<h4 className='c15 fs1-5rem fw500 pl3rem pr mb0-5rem'>
									<span className='numer br100 w2rem h2rem fs1rem bg17 c15 pa l0 tac df aic jcc t0 mt0-5rem'>4</span>
									Start Creating Value
								</h4>
								<p className='c14 fs1-25rem pl3rem'>You work collaboratively with your clients to create value for everyone.</p>
							</div>
							<div className='registration-box w33 p1rem bsbb mb2rem'>
								<h4 className='c15 fs1-5rem fw500 pl3rem pr mb0-5rem'>
									<span className='numer br100 w2rem h2rem fs1rem bg17 c15 pa l0 tac df aic jcc t0 mt0-5rem'>5</span>
									Additional Revenue
								</h4>
								<p className='c14 fs1-25rem pl3rem'>Help existing and new clients with Diligentsia Pro PLUS. Generate new client introduction via leads module.</p>
							</div>
							<div className='w100 mt2rem'>
								<p className='c14 fw500 fs1-25rem'>Rapidly increase the value of your firm!</p>
							</div>
							<div className='icon-crown pa' style={{ bottom: '-23px', right: '-25px' }}>
								<svg width="212" height="212" viewBox="0 0 212 212" fill="none" xmlns="http://www.w3.org/2000/svg">
									<g opacity="0.2">
										<path d="M164.422 160.762H47.5861C41.5472 160.762 36.6328 165.676 36.6328 171.715C36.6328 177.754 41.5472 182.668 47.5861 182.668H164.422C170.461 182.668 175.375 177.754 175.375 171.715C175.375 165.676 170.461 160.762 164.422 160.762Z" fill="#F9E109" />
										<path d="M182.674 51.2309C174.62 51.2309 168.069 57.7811 168.069 65.8353C168.069 71.2464 171.063 75.9269 175.452 78.4534C167.003 98.4614 153.823 110.737 141.504 109.627C127.805 108.509 116.632 92.313 110.469 65.2146C118.37 63.2136 124.256 56.0939 124.256 47.5798C124.256 37.51 116.07 29.3242 106 29.3242C95.9303 29.3242 87.7445 37.51 87.7445 47.5798C87.7445 56.0943 93.6302 63.2139 101.531 65.2146C95.368 92.313 84.1954 108.509 70.4966 109.627C58.229 110.737 44.9898 98.4614 36.5487 78.4534C40.9372 75.9269 43.9312 71.246 43.9312 65.8353C43.9312 57.7811 37.3809 51.2309 29.3267 51.2309C21.2729 51.2309 14.7227 57.7811 14.7227 65.8353C14.7227 73.3276 20.4182 79.4468 27.6912 80.279L41.7555 153.462H170.245L184.309 80.279C191.583 79.4468 197.278 73.3276 197.278 65.8353C197.278 57.7811 190.728 51.2309 182.674 51.2309Z" fill="#FCBC04" />
									</g>
								</svg>
							</div>
						</div>
					</div>
					<svg className="pa cp" onClick={() => dispatch(toggleModal({ open: "" }))} style={{ left: '50%', transform: 'translateX(-50%)', bottom: '-83px' }} width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
						<rect opacity="0.8" x="4" y="4" width="52" height="52" rx="26" fill="#151313" />
						<path d="M48.5626 11.4375C44.8913 7.76665 40.214 5.26685 35.1221 4.2542C30.0302 3.24156 24.7523 3.76155 19.9559 5.74843C15.1595 7.73531 11.06 11.0998 8.17569 15.4166C5.29142 19.7333 3.75195 24.8084 3.75195 30C3.75195 35.1917 5.29142 40.2667 8.17569 44.5835C11.06 48.9002 15.1595 52.2647 19.9559 54.2516C24.7523 56.2385 30.0302 56.7585 35.1221 55.7458C40.214 54.7332 44.8913 52.2334 48.5626 48.5625C51.0004 46.1249 52.9342 43.231 54.2535 40.0461C55.5729 36.8611 56.252 33.4474 56.252 30C56.252 26.5526 55.5729 23.1389 54.2535 19.954C52.9342 16.769 51.0004 13.8751 48.5626 11.4375ZM39.3751 36.6375C39.5624 36.8129 39.7117 37.0249 39.8138 37.2603C39.9159 37.4958 39.9686 37.7496 39.9686 38.0063C39.9686 38.2629 39.9159 38.5168 39.8138 38.7522C39.7117 38.9876 39.5624 39.1996 39.3751 39.375C39.1999 39.5488 38.9921 39.6863 38.7636 39.7796C38.5352 39.8729 38.2906 39.9202 38.0438 39.9188C37.5519 39.9167 37.0805 39.7214 36.7313 39.375L30.0001 32.6438L23.3626 39.375C23.0133 39.7214 22.5419 39.9167 22.0501 39.9188C21.8033 39.9202 21.5587 39.8729 21.3302 39.7796C21.1018 39.6863 20.894 39.5488 20.7188 39.375C20.3696 39.0237 20.1736 38.5485 20.1736 38.0531C20.1736 37.5578 20.3696 37.0826 20.7188 36.7313L27.3563 30L20.7188 23.3625C20.4116 23.0038 20.2511 22.5424 20.2694 22.0705C20.2876 21.5986 20.4832 21.151 20.8171 20.8171C21.1511 20.4832 21.5987 20.2875 22.0706 20.2693C22.5425 20.2511 23.0039 20.4116 23.3626 20.7188L30.0001 27.3563L36.6376 20.7188C36.8111 20.539 37.0184 20.3952 37.2476 20.2956C37.4768 20.196 37.7233 20.1424 37.9732 20.1381C38.223 20.1337 38.4713 20.1786 38.7038 20.2702C38.9363 20.3618 39.1484 20.4983 39.3282 20.6719C39.5079 20.8455 39.6517 21.0528 39.7514 21.2819C39.851 21.5111 39.9045 21.7576 39.9089 22.0075C39.9132 22.2573 39.8683 22.5056 39.7767 22.7381C39.6851 22.9706 39.5486 23.1828 39.3751 23.3625L32.6438 30L39.3751 36.6375Z" fill="white" />
					</svg>
				</div>
			</Modal>

			{/* Add/Edit/Delete Advisor */}
			<TeamMemberModal
				userType="nonCompany"
				modal={modal}
				getAdvisors={getAdvisors}
				onModalClose={onModalClose}
				user={user}
				action={action}
				advisorData={advisorData}
				profileClass={profileClass}
				setUpdateType={setUpdateType}
				setUploadImage={setUploadImage}
				setSelectedData={setSelectedData}
				hideUserIcon={hideUserIcon}
				setAdvisorData={setAdvisorData}
				setSelectAll={setSelectAll}
				selectAll={selectAll}
				sections={sections}
				setPermissions={setPermissions}
				permissions={permissions}
				company={company}
			/>

			{/* Confirmation Adding Advisor */}
			<Modal open={modal["open"] == "addingAdvisor"} onClose={() => dispatch(toggleModal({ open: "" }))} className="backdrop td500 zi4 pf t0 l0 w100 h110vh df jcc aic">
				<div className="mah90 oya bg1 shadow w100 bsbb df fdc m1rem maw600px br10px pr">
					<div className='top-header py1rem px2rem df jcsb aic' style={{ backgroundColor: '#FFF6A680', borderRadius: '8px 8px 0 0' }}>
						<h4 className='fs1-5rem c15 fw500 ttc'>{user["role"]} Added</h4>
						<img className="w60px" src={require(`../../../../images/logo-icon.svg`)} alt="TODO" />
					</div>
					<div className="df fdc gg1rem px2rem py2rem">
						<p className="fs1rem py1rem">
							Congratulations! Team Member has been added, now Team Member has been sent an email on the provided email
							address from where he/she can gain access to the platform.
						</p>
						<div className="df jcc">
							<span onClick={() => dispatch(toggleModal({ open: "" }))} className="w30 shadow bg4 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic">
								Close
							</span>
						</div>
					</div>
				</div>
			</Modal>

			{/* Upload Profile */}
			<Modal open={modal["open"] == "uploadProfile"} onClose={() => dispatch(toggleModal({ open: "" }))} className="backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic">
				<div className="mah90 oya bg1 shadow w100 bsbb df fdc m1rem maw600px br10px pr">
					<div className='top-header py1rem px2rem df jcsb aic' style={{ backgroundColor: user['role'] == 'Investor' ? '#AAFED680' : '#FFF6A680', borderRadius: '8px 8px 0 0' }}>
						<h4 className='fs1-5rem c15 fw500 ttc'>Upload Profile Picture</h4>
						<img className="w60px" src={require(`../../../../images/logo-icon.svg`)} alt="TODO" />
					</div>
					<div className='df fdc p3rem'>
						{uploadImage == "" ? (
							<label for="profile" className="w100 bsbb bg5 br5px tac p1rem bsd bo6 bw2px cp pr upload-pic-area">
								<span className="pen fs1rem fw500 tac">Upload picture</span>
								<br />
								<div className="">
									<input
										type="file"
										className=""
										id="profile"
										onChange={(e) => handleUploadImage(e)}
										accept="image/jpeg, image/jpg, image/png"
									/>
								</div>
								<label>Max file size 5MB</label>
							</label>
						) : (
							<div className="img-box pr">
								<Cropper
									ref={cropper}
									guides={false}
									src={uploadImage}
									aspectRatio={1 / 1}
									className="cropper-settings"
									style={{ maxHeight: "500px" }}
								/>
							</div>
						)}
						<div className="df jcse">
							<span
								onClick={() => cancelUpdateProfile()}
								className="shadow bg4 bg4-hover c1 td250 br5px px2rem py0-5rem cp ttu mr1rem bsbb tac df jcc aic mt1rem">
								Cancel
							</span>
							<span
								onClick={() => { if (!loading) updateProfile() }}
								className={`shadow bg3 bg4-hover c1 td250 br5px px2rem py0-5rem cp ttu mr1rem bsbb tac df jcc aic mt1rem ${loading && "button-disabled"}`}>
								{Object.keys(uploadImage).length == 0
									? "Upload"
									: "Crop & Upload"}
							</span>
						</div>
					</div>
				</div>
			</Modal >

			{/* Business Card Modal */}
			<Modal open={selectedData} onClose={() => setSelectedData('')} className="td500 zi4 pf t0 l0 w100 h110vh df jcc aic">
				<BusinessCards
					setSelectedData={setSelectedData}
					selectedData={selectedData}
					onEditClick={onEditClick}
					profileClass={profileClass}
					user={user} />
			</Modal>

		</AnimatedPage >
	);
};